import React from "react";
import AccountPage from "../account/AccountPage";
export default function SignIn() { return <AccountPage mode="login"/>; }
